import _remove from 'lodash/remove';
import addStudentTemplate from './../../settings/add-student/add-student.html';
import template from './edit-talk.html';

class EditTalkComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, $state, moment,
    TalkService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$state = $state;
    this.moment = moment;
    this.TalkService = TalkService;

    this.selectedStudents = [];
    this.selectedStudentsIDs = [];
    this.disableAddStudent = false;
  }

  $onInit() {
    this.date = this.moment(this.talk.date).toDate();
    this.selectedStudents = this.talk.students;
    this.selectedStudents.forEach(student => {
      this.selectedStudentsIDs.push(Number(student.id));
    });
  }

  $onChanges(changes) {
    if (changes.talk) {
      this.talk = {...this.talk};
    }
  }

  addStudent(ev) {
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'AddTalkStudentController',
      template: addStudentTemplate,
      locals: {talkId: this.talk.id},
      clickOutsideToClose: true,
      targetEvent: ev
    })
      .then(result => {
        _remove(this.selectedStudents, student => student.id === result.id);
        this.selectedStudents.unshift(result);
        this.selectedStudentsIDs.push(Number(result.id));
      }, () => {});
  }

  removeStudent(studentToRemove) {
    this.disableAddStudent = true;
    _remove(this.selectedStudents, student => student.id === studentToRemove.id);
    _remove(this.selectedStudentsIDs, id => id === Number(studentToRemove.id));
    this.talk.date = this.moment(this.date).format('YYYY-MM-DD');
    this.talk.students = this.selectedStudentsIDs;
    this.talk.studentObjects = this.selectedStudents;
    this.TalkService.edit({data: this.talk})
      .then(() => {
        this.disableAddStudent = false;
      })
      .catch(() => {
        this.disableAddStudent = false;
      });
  }

  edit(form) {
    if (form.$invalid) {
      return false;
    }

    this.talk.date = this.moment(this.date).format('YYYY-MM-DD');
    this.talk.students = this.selectedStudentsIDs;
    this.talk.studentObjects = this.selectedStudents;

    this.TalkService.edit(
      {
        data: this.talk
      }
    ).then(() => {
      this.$state.go('modules.talks');
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Edytowano rozmowę')
          .position('bottom right')
          .hideDelay(3000)
      );
    })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }
}

export const EditTalk = {
  bindings: {
    talk: '<'
  },
  template,
  controller: EditTalkComponent
};
